<template>
  <div id="detail">
    <div id="sm-menu">
      <img v-on:click="closeMenu()" src="../assets/close.png" id="close" alt="オンライン専門ZOOMコンパニオン「ズムトーーーク☆」">
      <ul>
        <a href="/"><li class="hover">トップページ</li></a>
        <a href="/menu"><li class="hover">料金システム</li></a>
        <a href="/companion"><li class="hover">コンパニオン</li></a>
        <a href="/service"><li class="hover">サービス紹介</li></a>
        <a href="/contact"><li class="hover">お問い合わせ</li></a>
      </ul>
    </div>
    <SubHeader/>
    <div class="top">
       <p class="subTitle-row">プロフィール</p>
    </div>
    <div class="flexbox">
      <article class="main">
        <img src="" id="thumbnail">
        <Carousel
        :per-page="2"
        :navigation-enabled="false"
        :speed="500" id="carousel"
        :loop="true">
          <Slide
          data-index="0"
        data-name="MySlideName"
        @slideclick="handleSlideClick">
            <img src="" id="thumbnail0">
          </Slide>
          <Slide
          data-index="1"
        data-name="MySlideName"
        @slideclick="handleSlideClick">
            <img src="" id="thumbnail1">
          </Slide>
          <Slide
          data-index="2"
        data-name="MySlideName"
        @slideclick="handleSlideClick">
            <img src="" id="thumbnail2">
          </Slide>
        </Carousel>
      </article>
      <section class="side">
        <table>
          <tr>
            <th class="title"><p>名前</p></th>
            <th class="value"><p id="name"></p></th>
          </tr>
          <tr>
            <td class="title"><p>年齢</p></td>
            <td class="value"><p id="age"></p></td>
          </tr>
          <tr>
            <td class="title"><p>出身</p></td>
            <td class="value"><p id="from"></p></td>
          </tr>
          <tr>
            <td class="title"><p>血液型</p></td>
            <td class="value"><p id="blood"></p></td>
          </tr>
          <tr>
            <td class="title"><p>星座</p></td>
            <td class="value"><p id="sign"></p></td>
          </tr>
          <tr>
            <td class="title"><p>趣味</p></td>
            <td class="value"><p id="hobby"></p></td>
          </tr>
          <tr>
            <td class="title"><p>特技</p></td>
            <td class="value"><p id="skill"></p></td>
          </tr>
          <tr>
            <td class="title"><p>コメント</p></td>
            <td class="value"><p id="comment"></p></td>
          </tr>
        </table>
      </section>
    </div>
     <div class="reserve-button-wrap">
    <a class="reserve-button" href="https://coubic.com/kei-corporation/943293#pageContent" target="_blank">予約はこちら</a>
    </div>
    <Footer/>
  </div>
</template>
<style scoped>
.subTitle-row{
 background-image: url(../assets/bg-title.jpg);
background-size:cover;
  height: 50px;
  line-height: 50px;
 color:white;
 box-shadow: 4px 4px #005FFF;
  width: 70%;
  margin:36px auto;
  font-size:24px;
  border-radius: 5px 5px 5px 5px;
  font-weight: bold;
  border: 5px solid  white;
}
.main {
  margin-bottom: 10px;
  width: 30%;
}
.reserve-button{
background-color:#FFA07A;
  padding: 8px;
  width: 400px;
  font-size: 36px;
  border-radius: 30px;
  color: white!important;
}
.reserve-button-wrap{
  margin: 5%;
}
.reserve-button-wrap a{
  text-decoration: none;
  color: white;
}
.reserve-button-wrap a:hover{
  background-color:#FF8C00;
}
.side {
    background-color: white;
   box-shadow: 4px 4px #006600;
  width: 70%;
  margin: 0 auto;
  text-align: center;
}
#carousel img{
  width: 90%;
}
.main,
.side {
  padding: 2%;
}
.value{
  color: #555555;
  font-size: 24px;
  font-weight: bold;
}
.value p{
  text-align: center;
}
.top{
  padding-top: 0px;
}
#thumbnail{
  width: 100%;
}
table{
  width: 100%;
}
span{
 font-size: 24px;
 width: 200px!important;
  font-weight: bold;
  background-color:white;
  padding:10px;
  color: rgba(255,54,127,0.7);
}
.title{
  width: 30%;
}
.title p{
  text-align: center;
  color: white;
  width: 90%;
  display: table;
  background-color: #006600;
  font-size:24px;
  margin-left: 36px;
  padding-left: 8px;
  padding-right: 8px;
  font-weight: bold;
}
.value{
  text-align: left;
}
.value p{
   width: 80%;
    margin: 0 auto;
}
@media ( min-width : 600px ){
    .flexbox {
    display: -webkit-flex;
    display: flex;
    width: 70%;
    margin:0 auto;
    margin-bottom: 36px;
    }
  .main {
    margin: 0 10px 0 0;
  }
  #companion .flexbox {
    width: 80%;
    padding-left: 0%;
}
}
#sm-menu{
  background-color:rgba(0,0,0,0.9);
  display: none;
  z-index: 10000;
  width: 100%;
  height: 100%;
  background-color: black;
  position: fixed;
}
#close{
display: block;
position: absolute;
width: 64px;
height:64px;
top:16px;
right:16px;
}
@media ( max-width : 680px ){
   .subTitle-row{
  margin:0px auto;
}
#carousel img{
  width: 80%;
}
.top{
  padding-top: 100px;
}
 a{
    color: #555555!important;
   font-weight: bold;
  text-decoration: none;
  font-size:24px;
}
  #sm-menu li{
    display: block;
   background-image: url(../assets/bg-body.jpg);
    color: #555555!important;
     margin-left: 16px;
     margin-right: 16px;
    margin-top: 16px;
     margin-bottom: 16px;
     font-size:24px;
     line-height: 70px;
  border-radius: 10px 10px 10px 10px;
  height: 70px;
  }
  #sm-menu  li a{
   color: white;
  text-decoration: none;
  font-size:24px;
  line-height:70px;
}
  #sm-menu ul{
    margin-top: 100px;
     color: #555555!important;
     padding:inherit;

  }
  .value{
  font-size: 15px;
  padding-left: 16px;
}

  .subTitle-row{
    width: 90%;
  }
  #companion .subTitle-row p{
    color: #555555;
  }
  #companion .item {
  background-color: white;
  box-shadow: 4px 4px #555555;
  margin: 0 auto;
  width: 30%;
  text-align: center;
}
#companion .flexbox {
    display: flex;
    flex-wrap: wrap;
    width: 90%;
    margin-left: 5%;
    justify-content: center;
    }
.main {
  margin: 0 auto;
  width: 90%;
  margin-bottom: 36px;
  padding:0%;
  margin-top: 36px;
}
.side {
 background-color: white;
  width: 90%;
  margin: 0 auto;
  padding:0%;
  margin-bottom: 36px;
}
.title{
  width: 40%;
}
.title p{
  margin:5%;
}

}
</style>
<script>
import SubHeader from './common/SubHeader'
import Footer from './common/Footer'
import firebase from 'firebase'
import { Carousel, Slide } from 'vue-carousel'

export default {
  name: 'detail',
  components: {
    SubHeader, Footer, Carousel, Slide
  },
  data () {
    return {
      db: null,
      name: ''
    }
  },
  created: function () {
    var parameters = location.search
    var id = parameters.slice(4)
    if (!id) {
      console.log('AAAAABBBBb')
    } else {
      this.db = firebase.firestore()
      var docRef = this.db.collection('companions').doc(id)
      docRef.get().then(function (doc) {
        if (doc.exists) {
          document.getElementById('carousel').style.display = 'block'
          console.log('Document data:', doc.data())
          document.getElementById('name').innerHTML = doc.data().name
          document.getElementById('age').innerHTML = doc.data().age
          document.getElementById('from').innerHTML = doc.data().from
          document.getElementById('blood').innerHTML = doc.data().blood
          document.getElementById('sign').innerHTML = doc.data().sign
          document.getElementById('hobby').innerHTML = doc.data().hobby
          document.getElementById('skill').innerHTML = doc.data().skill
          document.getElementById('comment').innerHTML = doc.data().comment
          document.getElementById('thumbnail').src = doc.data().thumbnail
          if (!doc.data().thumbnailList) {
            document.getElementById('carousel').style.display = 'none'
          } else {
            document.getElementById('thumbnail0').src = doc.data().thumbnailList[0]
            document.getElementById('thumbnail1').src = doc.data().thumbnailList[1]
            document.getElementById('thumbnail2').src = doc.data().thumbnailList[2]
          }
        } else {
          alert('コンパニオンの詳細を取得できませんでした。')
          location.href = '/'
        }
      }).catch(function (error) {
        console.log(error)
        alert('コンパニオンの詳細を取得できませんでした。')
        location.href = '/'
      })
    }
  },
  mounted: function () {
  },
  methods: {
    closeMenu: function () {
      document.getElementById('sm-menu').style.display = 'none'
      document.getElementById('sm-menu-icon').style.display = 'block'
    },
    handleSlideClick: function (dataset) {
      console.log(dataset.index, dataset.name)
      var idName = 'thumbnail' + dataset.index
      console.log(idName)
      document.getElementById('thumbnail').src = document.getElementById(idName).src
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Detail.vue